module.exports = __webpack_public_path__ + "img/567.d6f85433.jpg";